export function getErrorDesc(error) {
    let desc = '';
    let err = error.response;
    if (err) {
        if (err.status) desc = '[' + err.status + '] ';
        if (err.statusText) desc = desc + err.statusText + ' ';
        if (err.data && err.data.message) desc = desc + " - " + err.data.message;

    }
    else {
        desc = error.message;
    }
    return desc;
}

// Format date to YYYY-MM-DD
export function date2strISO(dateVal) {
    let date = new Date(dateVal);
    let formattedDate = `${date.getFullYear()}-${('0' + (date.getMonth() + 1)).slice(-2)}-${('0' + date.getDate()).slice(-2)}`;
    return formattedDate;
}

export function getDate() {
    return date2strISO(new Date());//.split('T')[0];
}

// Format date to DD/MM/YYYY
export function date2str(dateVal) {
    let date = new Date(dateVal);
    let formattedDate = `${('0' + date.getDate()).slice(-2)}/${('0' + (date.getMonth() + 1)).slice(-2)}/${date.getFullYear()}`;
    return formattedDate;
}

export function dateTime2str(dateTime) {
    if (!dateTime) return '';
    let formattedDate = dateTime;
    try {
        // Parse the datetime string directly to avoid timezone conversion
        // Expected formats: "YYYY-MM-DD HH:mm:ss" or "YYYY-MM-DDTHH:mm:ss"
        const str = String(dateTime).replace('T', ' ').replace('Z', '');
        const match = str.match(/^(\d{4})-(\d{2})-(\d{2})\s+(\d{2}):(\d{2}):(\d{2})/);
        if (match) {
            const [, year, month, day, hour, minute, second] = match;
            formattedDate = `${day}/${month}/${year} ${hour}:${minute}:${second}`;
        } else {
            let date = new Date(dateTime);
            formattedDate = `${('0' + date.getDate()).slice(-2)}/${('0' + (date.getMonth() + 1)).slice(-2)}/${date.getFullYear()} ${('0' + date.getHours()).slice(-2)}:${('0' + date.getMinutes()).slice(-2)}:${('0' + date.getSeconds()).slice(-2)}`;
        }
    }
    catch { }

    return formattedDate;
}

/**
 * Converts an ISO 8601 date-time string to a formatted date-time string in UTC.
 * 
 * @param {string} isoString - The ISO 8601 date-time string to be converted.
 * @param {boolean} [dateOnly=false] - A flag to return only the date portion.
 * @returns {string} The formatted date-time string in 'YYYY-MM-DD HH:MM:SS' format or just 'YYYY-MM-DD' if dateOnly is true.
 */
export function formatDateTime(isoString, dateOnly=false) {
    const date = new Date(isoString);
    const year = date.getUTCFullYear();
    const month = String(date.getUTCMonth() + 1).padStart(2, '0');
    const day = String(date.getUTCDate()).padStart(2, '0');

    if (dateOnly) {
        return `${day}/${month}/${year}`;
    }
    const hours = String(date.getUTCHours()).padStart(2, '0');
    const minutes = String(date.getUTCMinutes()).padStart(2, '0');
    const seconds = String(date.getUTCSeconds()).padStart(2, '0');
    return `${day}/${month}/${year} ${hours}:${minutes}:${seconds}`;
}

export function getFullName(r) {
    if (r)
        return r.firstname + " " + (r.middlename && r.middlename != null ? r.middlename + " " : "") + r.surname;
    else
        return '';
}